import { render } from "./OrderCompany.vue?vue&type=template&id=c5819d3e"
import script from "./OrderCompany.vue?vue&type=script&lang=js"
export * from "./OrderCompany.vue?vue&type=script&lang=js"

import "./OrderCompany.vue?vue&type=style&index=0&id=c5819d3e&lang=less"

import exportComponent from "E:\\H5\\order_food\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__